import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import ColumnButton from "src/components/Page/GridButtons/ColumnButton";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteFileTypeSaga,
  getFileTypeDetailsSaga,
  getFileTypeListSaga,
} from "src/store/file-types/saga";
import { FileTypeDetailDto, FileTypeDto } from "src/store/file-types/type";
import FileTypeCreateForm from "./create";
import FileTypeEditForm from "./edit";
const FileTypePage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState<FileTypeDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<FileTypeDetailDto>();
  const columns = [
    {
      text: t("FileType.TypeName"),
      dataField: "TypeName",
    },
    {
      text: t("FileType.ModuleType"),
      dataField: "ModuleTypeName",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("FileType.PageTitle")}
        metaTag={t("FileType.MetaTag")}
        gridProps={{
          addTitle: t("FileType.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getFileTypeListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getFileTypeDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: FileTypeDto) =>
              t("FileType.DeleteQA", {
                name: data.TypeName,
              }),
            action: deleteFileTypeSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <FileTypeCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getFileTypeListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <FileTypeEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getFileTypeListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default FileTypePage;
